var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#091C00",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1440_3959)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1496 10L22 10.5608V26.8353L22.1496 27L29 22.5346L22.1496 10Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10L15 22.5346L22 27V19.1009V10Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0851 28.1926L22 28.2991V33.7449L22.0851 34L29 24L22.0851 28.1926Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 34V28.1926L15 24L22 34Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 27.0001L29 22.4777L22 19.0001V27.0001Z",
    fill: "#091C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22.4777L22 27.0001V19.0001L15 22.4777Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_3959"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/ethIcon.9c1bb1681cf2f181dcd8f8d57880a2be.svg";
export { ForwardRef as ReactComponent };